import React from 'react'
import PropTypes from 'prop-types'
import Content, {HTMLContent} from '../components/Content'
import Helmet from "react-helmet";
import Color from '../components/Colors'
import ProjectPhoto from "../components/ProjectPhoto";

export const ProjectPageTemplate = ({
                                        title,
                                        description,
                                        hero,
                                        content,
                                        contentComponent,
                                        theme,
                                        photos
                                    }) => {
    const PostContent = contentComponent || Content
    return (
        <div>
            <Helmet
                title={`${title} | Jennifer Emerling | Visual Storyteller in California`}
                bodyAttributes={{
                    class: `page-project theme-${theme}`
                }}/>
            <div className="hero is-fullheight is-hidden-mobile">
                <div className="hero-body"
                     style={{
                         paddingLeft: 0,
                         paddingRight: 0,
                         backgroundSize: 'cover',
                         backgroundImage: `url(${hero.image})`
                     }}>
                    <div className="container has-text-centered">
                        <h1 className="title is-3" style={{color: Color.white}}>{hero.heading}</h1>
                    </div>
                </div>
            </div>
            <div className="is-hidden-tablet">
                <div className=""
                     style={{
                         paddingLeft: 0,
                         paddingRight: 0,

                     }}>
                    <div className="container has-text-centered">
                        <img src={hero.image} alt={hero.heading} />
                        <h1 className="title is-3"
                            style={{
                                color: Color.white,
                                position: 'absolute',
                                top: '40%',
                                width: '100%'
                            }}>{hero.heading}</h1>
                    </div>
                </div>
            </div>
            <div className="section section-content-wrapper content has-margin-bottom-none has-padding-bottom-none">
                <PostContent content={content}/>
            </div>
            <div className="hero">
                <div className="hero-body has-padding-left-xxxl has-padding-right-xxxl">
                    {photos.map((photo, index) => {
                        console.log(index);
                        return (
                            <div key={index} className="photo has-margin-bottom-md">
                                <ProjectPhoto url={photo.url} alt={photo.alt} caption={photo.caption} />
                            </div>
                        )
                    })}
                </div>
            </div>

        </div>
    )
}

ProjectPageTemplate.propTypes = {
    title: PropTypes.string,
    description: PropTypes.string,
    hero: PropTypes.shape({
        image: PropTypes.string,
        heading: PropTypes.string
    }),
    content: PropTypes.string.isRequired,
    contentComponent: PropTypes.func,
    theme: PropTypes.string,
    photos: PropTypes.array,
}

const ProjectPage = ({data}) => {
    const {markdownRemark: page} = data
    return (
        <ProjectPageTemplate
            title={page.frontmatter.title}
            description={page.frontmatter.description}
            content={page.html}
            contentComponent={HTMLContent}
            hero={page.frontmatter.hero}
            photos={page.frontmatter.photos}
            theme={page.frontmatter.theme}
        />
    )
}

ProjectPage.propTypes = {
    data: PropTypes.shape({
        markdownRemark: PropTypes.object,
    }),
}

export default ProjectPage

export const projectPageQuery = graphql`
  query ProjectPage($id: String!) {
    markdownRemark(id: { eq: $id }) {
      html
      frontmatter {
        title
        description
        hero {
          image
          heading
        }
        photos{
          alt
          url
          caption
        }
        theme
      }
    }
    
  }
`



// WEBPACK FOOTER //
// ./src/templates/project-page.js